<template>
  <v-card outlined>
    <v-btn-toggle
      :value="dateRange"
      dense
      group
      mandatory
      color="primary"
      class="flex-wrap"
    >
      <v-tooltip
        v-for="(option, i) in dateOptions"
        :key="i"
        bottom
        color="grey darken-4"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            @click="rangeChange(option.value, option.range, i)"
            class="ma-0 caption font-weight-medium"
          >
            {{ option.text }}
          </v-btn>
        </template>
        <span>{{ option.tooltip }}</span>
      </v-tooltip>
    </v-btn-toggle>
  </v-card>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import { mapState } from 'vuex'

export default {
  name: 'DateBar',
  props: {
    dateRange: {
      type: Number,
      default: 3,
      required: true,
      validator: value => /[0-7]$/.test(value)
    },
    minDate: {
      type: String,
      default: '',
      required: false
    },
    formatDate: {
      type: String,
      default: 'unix',
      required: false
    }
  },
  data () {
    return {
      initialDateEnv: process.env.INITIAL_DATE || "2015-01-01",
      aWeekAgo: this.$moment()
        .subtract(6, 'days')
        .startOf('day'),
      fourWeeksAgo: this.$moment()
        .subtract(4, 'weeks')
        .startOf('day'),
      oneYearAgo: this.$moment()
        .subtract(1, 'year')
        .add(1, 'day')
        .startOf('day'),
      monthToDate: this.$moment().startOf('month'),
      quarterToDate: this.$moment().startOf('quarter'),
      yearToDate: this.$moment().startOf('year')
    }
  },
  computed: {
    ...mapState({ creationDateOrg: ({ auth: { user } }) => user.organization.created_at }),
    dateOptions () {
      return [
        {
          text: '1w',
          value: '1w',
          range: this.aWeekAgo,
          tooltip: this.$t('dates.1w')
        },
        {
          text: '4w',
          value: '4w',
          range: this.fourWeeksAgo,
          tooltip: this.$t('dates.4w')
        },
        {
          text: '1y',
          value: '1y',
          range: this.oneYearAgo,
          tooltip: this.$t('dates.1y')
        },
        {
          text: 'mtd',
          value: 'mtd',
          range: this.monthToDate,
          tooltip: this.$t('dates.mtd')
        },
        {
          text: 'qtd',
          value: 'qtd',
          range: this.quarterToDate,
          tooltip: this.$t('dates.qtd')
        },
        {
          text: 'ytd',
          value: 'ytd',
          range: this.yearToDate,
          tooltip: this.$t('dates.ytd')
        },
        {
          text: 'All',
          value: 'all',
          range: this.$moment(this.minDate || this.creationDateOrg),
          tooltip: this.$t('dates.all')
        },
        {
          text: this.$t('dates.custom'),
          value: 'customized',
          range: null,
          tooltip: this.$t('dates.custom')
        }
      ]
    }
  },
  methods: {
    rangeChange (value, date, index) {
      if (index !== this.dateRange) {
        let startDate
        if (date) {
          if (this.formatDate === 'unix') {
            startDate = date.unix()
          } else {
            startDate = date.format(this.formatDate)
          }
        }
        this.$emit('updateRange', value, startDate, index)
      }
    }
  }
}
</script>

<style></style>
